"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkupManager = void 0;
const SignallingServerConnection_1 = require("./SignallingServerConnection");
const WebSocketListener_1 = require("./WebSocketListener");
const logging_1 = require("../../util/logging");
class LinkupManager {
    constructor() {
        this.serverConnections = new Map();
        this.queryCallbacks = new Map();
        this.serverQueryCallback = (queryId, matches) => {
            let queryCallback = this.queryCallbacks.get(queryId);
            if (queryCallback !== undefined) {
                queryCallback(queryId, matches);
            }
        };
    }
    listenForMessagesNewCall(recipient, callback) {
        let connection = this.getLinkupServer(recipient.serverURL);
        connection.listenForMessagesNewCall(recipient, callback);
    }
    listenForMessagesOnCall(recipient, callId, callback) {
        let connection = this.getLinkupServer(recipient.serverURL);
        connection.listenForMessagesOnCall(recipient, callId, callback);
    }
    listenForRawMessages(recipient, callback) {
        let connection = this.getLinkupServer(recipient.serverURL);
        connection.listenForRawMessages(recipient, callback);
    }
    sendMessageOnCall(sender, recipient, callId, data) {
        let connection = this.getLinkupServer(recipient.serverURL);
        connection.sendMessage(sender, recipient, callId, data);
    }
    sendRawMessage(sender, recipient, data, sendLimit) {
        let connection = this.getLinkupServer(recipient.serverURL);
        connection.sendRawMessage(sender, recipient, data, sendLimit);
    }
    listenForQueryResponses(queryId, callback) {
        this.queryCallbacks.set(queryId, callback);
    }
    queryForListeningAddresses(queryId, addresses) {
        let queries = new Map();
        let direct = [];
        for (const address of addresses) {
            if (SignallingServerConnection_1.SignallingServerConnection.isWebRTCBased(address.serverURL)) {
                let q = queries.get(address.serverURL);
                if (q === undefined) {
                    q = new Array();
                    queries.set(address.serverURL, q);
                }
                q.push(address);
            }
            else {
                direct.push(address);
            }
        }
        for (const [serverURL, addresses] of queries.entries()) {
            let serverConnection = this.getLinkupServer(serverURL);
            LinkupManager.logger.trace(() => 'Sending query for listening addresses to ' + serverURL + ' for ' + addresses);
            serverConnection.sendListeningAddressesQuery(queryId, addresses);
        }
        const callback = this.queryCallbacks.get(queryId);
        if (callback !== undefined && direct.length > 0) {
            LinkupManager.logger.trace(() => 'Reporting websocket addresses as listening:' + JSON.stringify(direct));
            callback(queryId, direct);
        }
    }
    getLinkupServer(serverURL) {
        let serverConnection = this.serverConnections.get(serverURL);
        if (serverConnection === undefined) {
            if (SignallingServerConnection_1.SignallingServerConnection.isWebRTCBased(serverURL)) {
                serverConnection = new SignallingServerConnection_1.SignallingServerConnection(serverURL);
                serverConnection.listenForLinkupAddressQueries(this.serverQueryCallback);
            }
            else {
                serverConnection = new WebSocketListener_1.WebSocketListener(serverURL);
            }
            this.serverConnections.set(serverURL, serverConnection);
        }
        return serverConnection;
    }
    shutdown() {
        for (const serverConn of this.serverConnections.values()) {
            serverConn.close();
        }
    }
}
exports.LinkupManager = LinkupManager;
LinkupManager.logger = new logging_1.Logger(LinkupManager.name, logging_1.LogLevel.INFO);
LinkupManager.defaultLinkupServer = 'wrtc+wss://mypeer.net:443';
//# sourceMappingURL=LinkupManager.js.map